<template>
<!-- <transition appear name="appear"> -->
  <div class="Flow" :style="{'--r': parseInt(this.$settings.backgroundColor.slice(1,3),16), '--g': parseInt(this.$settings.backgroundColor.slice(3,5),16), '--b': parseInt(this.$settings.backgroundColor.slice(5,7),16)}">
      <transition name="delete-appear">
        <div class="delete-flow-container" v-if="flowToDelete">
          <DeleteFlow v-bind:flow="flowToDelete" v-on:reset="flowToDelete = null" v-on:delete="flows.splice($event,1)"></DeleteFlow>
        </div>
        <div class="delete-flow-container" v-if="flowToEdit">
          <EditFlow v-bind:flow="flowToEdit" v-on:reset="flowToEdit = null" v-on:edit="flows[$event.index].title = $event.title"></EditFlow>
        </div>
      </transition>
      <div class="home-container-top">
          <div class="greeting">
              <h2 class="greeting-text">{{greeting()}}  {{ $name }}.</h2>
              <hr>
              <h3 class="started" v-if="started()">{{started()}}</h3>
          </div>

        <div class="home-tabs">
          <!-- <div class="tab"><button class="home-button"><img src="../assets/img/quick-access.png" alt=""></button></div> -->
          <div class="tab"><button v-on:click="activeTab='Flow'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80.5 38.66" style="fill:none;stroke-miterlimit:10;stroke-width:4px;">
              <defs>
                <linearGradient id="linear" x1="0%" y1="0%" x2="150%" y2="0%">
                <stop offset="0%"   stop-color="lightblue"/>
                <stop offset="100%" stop-color="violet"/>
                <animate attributeName="x1" dur="10s" values="150%;-100%;150%" repeatCount="indefinite"/>
                </linearGradient>
              </defs>
              <g id="Layer_1-2" data-name="Layer 1"><path style="shape-rendering:geometricPrecision" stroke="url(#linear)" d="M0,38.16c23.74,0,37.63-9.3,43-18.91C49.43,7.67,59.33,1.68,80.47.5"/></g>
            </svg>
            <h3>Flow</h3></button>
          </div>
          <div class="tab"><button v-on:click="activeTab='Notebooks'">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 36.71 44.13"><defs><clipPath id="clip-path" transform="translate(-1.65)"><rect class="notebook-1" y="11.13" width="8" height="21.88"/></clipPath></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="notebook-2" x="2.6" y="1" width="33.11" height="42.13" rx="2.55"/><g class="notebook-3"><g id="_Grid_Repeat_" data-name="&lt;Grid Repeat&gt;"><ellipse class="notebook-4" cx="2.5" cy="12.88" rx="2.25" ry="0.5"/></g><g id="_Grid_Repeat_2" data-name="&lt;Grid Repeat&gt;"><ellipse class="notebook-4" cx="2.5" cy="17.7" rx="2.25" ry="0.5"/></g><g id="_Grid_Repeat_3" data-name="&lt;Grid Repeat&gt;"><ellipse class="notebook-4" cx="2.5" cy="22.51" rx="2.25" ry="0.5"/></g><g id="_Grid_Repeat_4" data-name="&lt;Grid Repeat&gt;"><ellipse class="notebook-4" cx="2.5" cy="27.33" rx="2.25" ry="0.5"/></g><g id="_Grid_Repeat_5" data-name="&lt;Grid Repeat&gt;"><ellipse class="notebook-4" cx="2.5" cy="32.15" rx="2.25" ry="0.5"/></g></g><rect class="notebook-5" x="8.31" y="31.01" width="7.73" height="2" rx="1"/><rect class="notebook-5" x="8.31" y="25.75" width="22.45" height="2" rx="1"/></g></g></svg>
            <h3>Notebooks</h3></button></div>
          <div class="tab"><button v-on:click="activeTab='Organisations'">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 34.51 33.42"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="sharing-1" d="M13.37,22.3c-.94-1.08-2.95-1.44-4.74-1.44s-3.8.35-4.74,1.43a1.16,1.16,0,0,0,0,1.47c.95,1.08,2.95,1.43,4.74,1.43s3.8-.35,4.74-1.43A1.15,1.15,0,0,0,13.37,22.3Z"/><path class="sharing-1" d="M11.41,15.59a2.59,2.59,0,0,1,0,.48,2.82,2.82,0,1,1-5.64,0,3.88,3.88,0,0,1,0-.48,2.82,2.82,0,0,1,5.56,0Z"/><path class="sharing-1" d="M31.61,9.8a4.69,4.69,0,0,0-3.35-1,4.7,4.7,0,0,0-3.36,1,.83.83,0,0,0,0,1,4.66,4.66,0,0,0,3.35,1,4.69,4.69,0,0,0,3.35-1A.81.81,0,0,0,31.61,9.8Z"/><path class="sharing-1" d="M30.22,5.06a2,2,0,0,1,0,.34,2,2,0,1,1-4,0,2,2,0,0,1,0-.34,2,2,0,0,1,3.93,0Z"/><path class="sharing-1" d="M31.61,30.88a4.63,4.63,0,0,0-3.35-1,4.7,4.7,0,0,0-3.36,1,.83.83,0,0,0,0,1,4.66,4.66,0,0,0,3.35,1,4.64,4.64,0,0,0,3.35-1A.8.8,0,0,0,31.61,30.88Z"/><path class="sharing-1" d="M30.22,26.14a1.87,1.87,0,0,1,0,.34,2,2,0,0,1-4,0,1.87,1.87,0,0,1,0-.34,2,2,0,0,1,3.93,0Z"/><path class="sharing-2" d="M.5,20.71V12.3A3.17,3.17,0,0,1,3.66,9.14H13.6"/><path class="sharing-3" d="M34,8.68V2.73A2.25,2.25,0,0,0,31.77.5h-7a2.24,2.24,0,0,0-2.23,2.23V8.68l-5.75,3.9"/><path class="sharing-3" d="M34,29.75V23.81a2.25,2.25,0,0,0-2.24-2.24h-7a2.24,2.24,0,0,0-2.23,2.24v1.38l-5.75-4.48V12.58"/></g></g></svg>
            <h3>Organisations</h3>
            </button></div>
          <!-- <div class="tab"><button v-on:click="activeTab='Buildings'"><h3>Buildings</h3></button></div> -->
          <div class="tab changesPage"><button v-on:click="$router.push({ name: 'calender'});">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 37.03 36.3"><defs><clipPath id="clip-path-cal"><rect class="calender-1" x="2.52" y="7.62" width="32" height="24.46"/></clipPath></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><g class="calender-2" id="cal-svg-months"><g id="_Grid_Repeat_1" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="2.72" y="7.92" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_2" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="11.21" y="7.92" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_3" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="19.7" y="7.92" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_4" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="28.2" y="7.92" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_5" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="2.72" y="17.61" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_6" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="11.21" y="17.61" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_7" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="19.7" y="17.61" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_8" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="28.2" y="17.61" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_9" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="2.72" y="27.3" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_10" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="11.21" y="27.3" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_11" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="19.7" y="27.3" width="5.98" height="4.46" rx="0.96"/></g><g id="_Grid_Repeat_12" data-name="&lt;Grid Repeat&gt;"><rect class="calender-3" x="28.2" y="27.3" width="5.98" height="4.46" rx="0.96"/></g></g><rect class="calender-5" x="0.5" y="2.57" width="36.03" height="33.23" rx="3.7"/><rect class="calender-4" x="7.78" width="0.94" height="3.58"/><rect class="calender-4" x="28.29" width="0.94" height="3.58"/></g></g></svg>
            <h3>Calender</h3>
            </button></div>
          <div class="tab changesPage"><button v-on:click="$router.push({ name: 'people'});">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.31 21.06"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="people-1" d="M26.43,17.36a1.62,1.62,0,0,1-.38,1.13c-1.37,1.57-4.29,2.07-6.89,2.07s-5.52-.51-6.9-2.08a1.69,1.69,0,0,1-.38-1.12,1.65,1.65,0,0,1,.38-1,5.8,5.8,0,0,1,2.8-1.57,15.46,15.46,0,0,1,4.1-.5,15.46,15.46,0,0,1,4.1.5,5.83,5.83,0,0,1,2.79,1.58A1.62,1.62,0,0,1,26.43,17.36Z"/><path class="people-1" d="M23.2,6.6a4,4,0,0,1,.06.7,4.1,4.1,0,0,1-8.2,0,4,4,0,0,1,.06-.7,4.1,4.1,0,0,1,8.08,0Z"/><path class="people-1" d="M15.06,14.77a5.8,5.8,0,0,0-2.8,1.57,1.65,1.65,0,0,0-.38,1,15.46,15.46,0,0,1-4.1.5c-2.61,0-5.52-.51-6.9-2.08a1.69,1.69,0,0,1,0-2.14c1.37-1.56,4.29-2.07,6.9-2.07s5.52.51,6.89,2.08A1.63,1.63,0,0,1,15.06,14.77Z"/><path class="people-1" d="M11.82,3.9a4,4,0,0,1,.06.7,4.1,4.1,0,0,1-8.2,0,4,4,0,0,1,.06-.7,4.1,4.1,0,0,1,8.08,0Z"/><path class="people-1" d="M37.43,15.79c-1.37,1.56-4.29,2.07-6.89,2.07a15.53,15.53,0,0,1-4.11-.5,1.62,1.62,0,0,0-.38-1,5.83,5.83,0,0,0-2.79-1.58,1.62,1.62,0,0,1,.38-1.13c1.37-1.56,4.29-2.07,6.9-2.07s5.51.51,6.89,2.08A1.69,1.69,0,0,1,37.43,15.79Z"/><path class="people-1" d="M34.58,3.9a4,4,0,0,1,.06.7,4.1,4.1,0,0,1-8.2,0,4,4,0,0,1,.06-.7,4.1,4.1,0,0,1,8.08,0Z"/></g></g></svg>
            <h3>People</h3>
            </button></div>
          <!-- <div class="tab"><button>Notebooks</button></div> -->
          <div class="tab changesPage"><button v-on:click="$router.push({ name: 'chat'});">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 39.31 27.35"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="chat-1" d="M26.15,19a1.49,1.49,0,0,1-.34,1c-1.23,1.4-3.83,1.85-6.15,1.85s-4.93-.46-6.15-1.86a1.48,1.48,0,0,1,0-1.9A5.06,5.06,0,0,1,16,16.68a13.8,13.8,0,0,1,3.66-.44,13.5,13.5,0,0,1,3.66.45,5.14,5.14,0,0,1,2.49,1.4A1.47,1.47,0,0,1,26.15,19Z"/><path class="chat-1" d="M23.26,9.39a3.35,3.35,0,0,1,0,.63A3.66,3.66,0,1,1,16,10a4.21,4.21,0,0,1,.05-.62,3.66,3.66,0,0,1,7.21,0Z"/><rect class="chat-1" x="0.5" y="3.51" width="38.31" height="21.2" rx="1.86"/><rect class="chat-1" x="11.23" y="24.71" width="16.84" height="2.15" rx="0.48"/><rect class="chat-2" x="13.96" width="11.39" height="2.64" rx="1.32"/></g></g></svg>
            <h3>Chat</h3></button>
            </div>
          
          <div class="tab external">
            <button v-on:click="$router.push({ name: 'about'});">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 4.82 17.91"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><rect class="about-1" y="6.24" width="4.82" height="11.67" rx="0.7"/><rect class="about-1" width="4.82" height="4.82" rx="1.95"/></g></g></svg>
              <h3>About</h3>
            </button>
          </div>

        </div>
      </div>

      <div class="home-container-bottom">
        <transition name="appear" appear mode="out-in">
        <FlowView v-bind:key="'flow'" v-if="activeTab=='Flow'" v-on:delete="flowToDelete=$event" v-on:edit="flowToEdit=$event" v-bind:flows.sync="flows" v-bind:notificationData.sync="notificationData" v-bind:notificationDataShared.sync="notificationDataShared"></FlowView>
        <NotebookView v-bind:key="'notebooks'" v-if="activeTab=='Notebooks'"></NotebookView>
        <OrganisationView v-bind:key="'org'" v-if="activeTab=='Organisations'"></OrganisationView>
        </transition>

      </div>

  </div>
<!-- </transition> -->
</template>

<script>

import FlowView from './HomeSubViews/FlowView.vue'
import DeleteFlow from '../Subviews/DeleteFlow.vue';
import EditFlow from '../Subviews/EditFlow.vue';
import NotebookView from './HomeSubViews/NotebookView.vue'
import OrganisationView from './HomeSubViews/OrganisationView.vue'

export default {
  components: {
      FlowView,
      DeleteFlow,
      EditFlow,
      NotebookView,
      OrganisationView
    },
    data(){
        return{
            flows:[],
            activeTab:"Flow",
            flowToDelete:null,
            flowToEdit:null,
            notificationData:null,
            notificationDataShared:null,


        }
    },
    mounted(){
        this.init();
        this.setCurrentlyActive();
        this.calFill() 
    },
    watch:{
      activeTab:function(){
        // console.log(this.activeTab)
        this.setCurrentlyActive();
      }
    },
    computed:{
    },
    methods:{
        init() {
          const flows = this.$api.get(`/api/flows`)
          const flowsShared = this.$apiShared.get(`/api/sharing/flows`)
          const notifications = this.$api.get(`/api/items/notification`)
          const notificationsShared = this.$apiShared.get(`/api/sharing/items/notification`)
          Promise.allSettled([flows,flowsShared])
          .then((values)=>{
            this.flows = [...(values[0].value?.data||[]),...(values[1].value?.data||[])]
          })
          Promise.allSettled([notifications,notificationsShared])
          .then((values)=>{
            this.notificationData = values[0].value?.data
            this.notificationDataShared = values[1].value?.data
          })
        },
        greeting() {
          var date = new Date();
          if (date.getHours() < 12) {
            return "Good Morning!";
          }
          if (date.getHours() < 17) {
            return "Good Afternoon!";
          } else {
            return "Good Evening!";
          }
        },
        started() {
          var date = new Date();
          if (date.getHours() < 12) {
            return "Let's get the day started!";
          } 
        },
        setCurrentlyActive(){
          document.querySelectorAll('.tab').forEach((tab)=>{
            tab.innerText != this.activeTab ? tab.classList.remove("currentlyActive") : tab.classList.add("currentlyActive")
          })
        },
        calFill(){
          const month = new Date().getMonth() + 1;
          const svgMonth = document.querySelector('#cal-svg-months').querySelector(`#_Grid_Repeat_${month}`)
          // console.log(svgMonth)
          svgMonth.children[0].style.fill="var(--text-color)"
        }
    }
}
</script>

<style>
.Flow{
    --c: calc(-1 * ((var(--r) * 0.299 + var(--g) * 0.587 + var(--b) * 0.114) - 186) * 255);
    height:90vh;
    width:100vw;
    position:relative;
    display:flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    overflow-y: auto;
    overflow-x: hidden;
}

.delete-flow-container{
    width:100vw;
    height:90vh;
    background-color: rgba(0, 0, 0, 0.397);
    position:absolute;
    z-index:100;

}

.greeting{
    display:flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    flex-grow:0;
    flex-shrink: 0;
    height:65%;
    margin-left: 50px;
    /* background-color: blueviolet; */
}
.greeting-text{
    margin:0;
    color: rgb(var(--c), var(--c), var(--c));
    /* color:rgb(255, 255, 255); */
    /* font-family: 'Helvetica Neue', sans-serif !important; */
    letter-spacing: 3px !important;
    /* font-size: min(3vw, 50px) !important; */
    
    /* font-weight: bold; */
    line-height: 1;
    align-self: flex-start;
    transition: color 1s;
    height: 40%;
}
hr{
  width:100px;
  height:1px;
  margin-left:0;
  background-color: rgb(var(--c), var(--c), var(--c));
  transition: background-color 1s;
  border:none;
}
.started{
    margin: 0;
    color: rgb(var(--c), var(--c), var(--c));
    font-family: neue-haas-unica,sans-serif !important;
    font-weight: 100 !important;
    font-style: normal;
    font-size: min(1.5vw, 25px) !important;
    letter-spacing: 2px;
    line-height: 1;
    justify-content: flex-end;
    transition: color 1s;
    height: 10%;
    /* text-align: left; */
}
.home-tabs{
  /* background-color: blueviolet; */
  align-self: end;
  height:80%;
  display:grid;
  width:55%;
  grid-template-columns:repeat(7,1fr);
  align-items: center;
  justify-items: center;
  grid-gap:5px;
  justify-content: end;
  margin-left: auto;
  margin-right: auto;


}

.home-tabs .tab{
  transition: all 0.2s ease-in-out;
  background-color: var(--color-light);
  height:60px;
  width:60px;
  border-radius:10px;
  position: relative;
  backdrop-filter: blur(0px);
  animation: blur-in 400ms ease-in 500ms forwards;
}

.home-tabs .tab:hover,.home-tabs .tab.currentlyActive{
  background-color: black;
  height:60px;
  width:100%;
  border-radius:5px;
}
.home-tabs .tab button{
  display:flex;
  justify-content: center;
  align-items: center;
  background-color:transparent;
  border:none;
  height:100%;
  width:100%;
  border-radius:inherit;
  color:var(--text-color);
}

.home-tabs .tab img, .home-tabs .tab svg{
  transition: all 0.1s ease-in-out;
  opacity:1;
  height:60%;
  width:auto;
}

.home-tabs .tab:hover img, .tab.currentlyActive img, .home-tabs .tab:hover svg, .tab.currentlyActive svg{
  opacity:0;
  width:0%;
}

.home-tabs .tab h3{
  transition: all 0.3s ease-in-out; 
  position: absolute;
  opacity:0;
  inset:0;
  margin:0;
  font-size: 1.2vw;
}

.home-tabs .tab:hover h3,.tab.currentlyActive h3{
  opacity:1;
}

.home-tabs .tab.changesPage{
  /* background-color: rgba(0, 255, 255, 0.322); */
  background-color: rgba(96, 96, 96, 0.322);
  /* background-color: var(--color-lightest); */
}

.home-tabs .tab.external{
  background-color: rgba(0, 128, 85, 0.471);
}

.home-button img {
  filter:var(--invert);
  height:30%;
}

.home-container-top{
  /* background-color: black; */
  width:100%;
  height:35%;
  display:flex;

  align-items: center;
}

.home-container-bottom{
    /* background-color: rgba(0, 255, 255, 0.507); */
    height:65%;
    width:100%;
    flex-shrink: 0;
    flex-grow: 1;
    
    /* min-height:525px; */
}

.home-container-bottom > *{
  opacity:1;
}


.delete-flow-button-container{
    pointer-events:none;
    /* display:none; */
    width:50%;
    height:100%;
    display: flex;
    justify-content: flex-end;
}
.delete-flow-button{
    border:none;
    height:100%;
    width:50%;
    background-color: rgb(197, 55, 55);
    border-radius:5px !important;
    color:white;
    /* background-color: red; */
}
.edit-flow-container{
    pointer-events:none;
    /* display:none; */
    width:50%;
    height:100%;
    display: flex;
    justify-content: flex-end;
}

.edit-flow-button{
  transition: all 0.2s ease-in-out;
  width:100%;
  border:none;
  background-color: var(--color-lightest);
  color:var(--text-color);
  border-radius:5px;
}

.edit-flow-button:hover{
  background-color: aliceblue;
}

.delete-appear-enter-active, .delete-appear-leave-active {
  transition: all 0.5s;

}
.delete-appear-enter, .delete-appear-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;

}
</style>
<style>.notebook-1,.notebook-2,.notebook-4{fill:none;shape-rendering:geometricPrecision}.notebook-2,.notebook-4{stroke:var(--text-color);stroke-miterlimit:10;}.notebook-2{stroke-width:2px;}.notebook-3{clip-path:url(#clip-path);}.notebook-4{stroke-width:0.5px;}.notebook-5{fill:var(--text-color);shape-rendering:geometricPrecision}</style>
<style>.people-1{fill:none;stroke:var(--text-color);stroke-miterlimit:10;shape-rendering:geometricPrecision}</style>
<style>.sharing-1,.sharing-2,.sharing-3{fill:none;stroke:var(--text-color);shape-rendering:geometricPrecision}.sharing-1,.sharing-2{stroke-miterlimit:10;}.sharing-2,.sharing-3{stroke-linecap:round;}.sharing-3{stroke-linejoin:round;}</style>
<style>.calender-1,.calender-3,.calender-5{fill:none;}.calender-3,.calender-5{stroke:var(--text-color);stroke-miterlimit:10;}.calender-3{stroke-width:0px;fill:rgba(255, 255, 255, 0.251);}.calender-4{fill:var(--text-color);}</style>
<style>.chat-1{fill:none;stroke:var(--text-color);stroke-miterlimit:10;shape-rendering:geometricPrecision}.chat-2{fill:var(--text-color);shape-rendering:geometricPrecision}</style>
<style>.about-1{fill:var(--text-color);opacity:0.8;}</style>